import React from "react";

export default function DateBetweenComp({
  maxValue,
  setMaxValue,
  minValue,
  setMinValue,
}) {
  return (
    <div className="flex w-full gap-x-[1%] p-2 ">
      <div className="flex flex-col gap-1 w-[49.5%]">
        <label>From this date </label>
        <input
          type="date"
          value={minValue}
          onChange={(e) => setMinValue(e.target.value)}
          className="border p-2 rounded-md"
        />
      </div>
      <div className="flex flex-col gap-1 w-[49.5%]">
        <label>To this date</label>
        <input
          type="date"
          value={maxValue}
          onChange={(e) => setMaxValue(e.target.value)}
          className="border p-2 rounded-md"
        />
      </div>
    </div>
  );
}
